import React, {useState,useEffect, useContext} from "react"
import ComponentGroup from "../ComponentGroup/ComponentGroup"
import PortfolioGroup from "../ComponentGroup/porfolioGroup"
import {Link} from "gatsby"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import {ConditionContext} from "../context/conditionContext"
import {ErrorContext} from "../context/errorContext"
import {JourneyContext} from "../context/journeyContext"
import { RepeatableContext } from "../context/repeatableContext"
import {SectionContext} from "../context/sectionContext"
import * as lookup from "../../../static/lookup.json";
import { DataLayerIntegration, getValueFromJourney } from "../services/helperFunctions"
import { getSectionDisplayName } from "../services/dynamicHeadings"

const Section = props => {
  console.log("propssections",props);
  let validForm = true
  const CPPersonalProceedCondition = (index)=>{
    return index>=4 && props.section.sectionId == "CPPersonalDetailsSection" && validForm
  }
  const [conditionState,setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState,setJourneyState] = useContext(JourneyContext)
  const [repeatableState,setRepeatableState] = useContext(RepeatableContext)
  const [sectionState, setSectionState] = useContext(SectionContext)

  const handleAdd = (element) =>{
    if(element.repeatableLimit){
      if(repeatableState[element.componentId].length > element.repeatableLimit){
        return
      }else {
        let temp = [...repeatableState[element.componentId], element]
        setRepeatableState(prev => {
          return ({
            ...prev,
            [element.componentId]: temp
          })
        })
      }
    }else {
    let temp = [...repeatableState[element.componentId], element]
    setRepeatableState(prev => {
      return ({
        ...prev,
        [element.componentId]: temp
      })
    })
  }
}
  const handleEnterAdd = (event,element) =>{
    if(event.key == 'Enter'){
      handleAdd(element)
    }

  }

  const handleEnterRemove = (event,element,index) =>{
    if(event.key == 'Enter'){
      handleRemove(element,index)

    }
  }
  const handleRemove = (element, index) => {
    if(index === 0){
      return 
    }else{
      let temp = repeatableState[element.componentId].filter((groups,i) => {
        return i !== index
      })
      setRepeatableState(prev => {
        return({
          ...prev,
          [element.componentId]: temp
        })
      })

      //removing from section state
      let tempNewSectionState = {}
      console.log(sectionState.sectionData, "checkdcdc")
      Object.keys(sectionState.sectionData).forEach(element => {
        let temp = sectionState.sectionData[element]
        if(Array.isArray(temp)){
          temp.splice(index,1)
        }
        tempNewSectionState[element] =  temp
      })
      console.log(tempNewSectionState, "checkdcdc1")
      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: tempNewSectionState
        })
      })
      //removing from error state
      let tempNewErrorState = {}
      Object.keys(errorState).forEach(element => {
        let temp = errorState[element]
        if(Array.isArray(temp)){
          temp.splice(index,1)
        }
        tempNewErrorState[element] = temp
      })
      console.log(tempNewErrorState, "newErrorState")
      setErrorState(tempNewErrorState)
    }
  }

  const standardCapital = (input)=>{
    if(input){
      var str = input?.split(" "); 
      var expected = "";
      str?.map(function(c){
        expected += c?.toLowerCase()?.replace(/^[a-z]/, c[0]?.toUpperCase())+ " "
      })
      expected = expected?.trim(); 
      return expected;
    }
  }
  //To manage state first repetableStateUpdate
  useEffect(() => {
    // console.log("useEffect", props.section)
    props.section?.component_groups.map((element, i) => {
      if(element.repeatable){
        if(!repeatableState[element.componentId]){
          if (sectionState.sectionData) {
            let repeatableStateLength
            element.components.forEach((comp) => {
              if (sectionState.sectionData[comp.formControlKey]) {
                // console.log(sectionState.sectionData[comp.formControlKey].length, "abcd12", repeatableState[element.componentId].length, "abcd13")
                repeatableStateLength = sectionState.sectionData[comp.formControlKey].length
              }
            })
            console.log(repeatableStateLength, "abcd15")
            if(repeatableStateLength){
              const length = repeatableStateLength
              let arr = []
              for (let i = 0; i < length; i++) {
                arr.push(element)
              }
              setRepeatableState(prev => {
                return ({
                  ...prev,
                  [element.componentId]: arr
                })
              })
            }else{
              setRepeatableState(prev => {
                return ({
                  ...prev,
                  [element.componentId]: [element]
                })
              })
            }
          } 
        }
        // else {
        //   setRepeatableState(prev => {
        //     return ({
        //       ...prev,
        //       [element.componentId]: [element]
        //     })
        //   })
        // }
      }
    })
  }, [props.section])

  const getRightSideContent = () => {
    const ApplicationNumberComponent = () => {
      return (
        <div className="app-quatation nri-mt-space hidden-desktop-screen">
          <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
        </div>
      )
    }
    if (props.currentSectionIndex === 0 && props.currentPageIndex === 0) {
      if (journeyState?.journeyType?.toLowerCase() !== "canarapos") {
        if(["EQUITAS", "equitas", "36"].includes(journeyState?.channel) && journeyState.applicationNo){
          return <ApplicationNumberComponent />
        }else {
          return (
            <Link className="resume-application" state={{ channel: journeyState.channel }}>
              <div className="iselect-padding right-side-resume" aria-hidden="true" onClick={() => window.location.href = process.env.GATSBY_RESUME_JOURNEY_LINK}>
                <h1 style={{ background: `${journeyState.channel === "A" ? "#ededed" : "#fff"}` }}>Resume Application</h1>
                <p>Continue with your existing application</p>
              </div>
            </Link>
          );
        }
      }
      return "";
    }
    return (
      <ApplicationNumberComponent />
    );
  };

  return (
    <>
      <div className={`${journeyState.journeySteps.showRideSideBar ? "col-lg-9 col-md-12 brd-right" : "col-md-12"}`}>
        <div className="iselect-box-design">
          {
            (props.currentSectionIndex === 0 && props.currentPageIndex === 0 && (journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "invest4GJourney" )) &&
            (<p class="plc" style={{fontSize: "15px", margin: "0px 0px 50px 20px", paddingLeft: "0px"}} > In this policy, the investment risk in investment portfolio is borne by the policyholder.</p>)
          }
          <div className="heading-design">
            <div className="iselect-padding left-side-head ckyc-w">
              <h1 className="iselect-heading">{getSectionDisplayName({
                section: props.section,
                conditionState,
                sectionState,
                journeyState,
                sections: props.sections,
              })}</h1>
            </div>
            {getRightSideContent()}
          </div>
          <div>
            {
              props.section?.sectionSubheading && (<p class="plc" style={{fontSize: "15px", margin: "80px 0px 0px 20px"}} ><h4>{props.section.sectionSubheading}</h4></p>)
            }
          </div>
          <div className="iselect-padding section-container ">
            <div className="row" >
              {props.section && props.section.component_groups.map((element, i) => {
                // If element is repeatable we are applying a loop to render them
                if(element.isPortfolioField){
                  if(element.class) {
                    return (
                      <div className={element.class} key={element.componentId + i}>
                        <PortfolioGroup
                          key={element.componentId + i}
                          data={element.components}
                          sectionId={props.section.sectionId}
                          pageId={props.pageId}
                          pages={props.pages}
                          currentSectionIndex={props.currentSectionIndex}
                          setCurrentSectionIndex={props.setCurrentSectionIndex}
                          currentPageIndex={props.currentPageIndex}
                          setCurrentPageIndex={props.setCurrentPageIndex}
                          sections={props.sections}
                          showError={props.showError}
                          setShowError={props.setShowError}
                          nvestFilterResult={props.nvestFilterResult}
                          saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                          journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                          channel={journeyState.channel}
                          firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                          setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                          showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                          setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                        ></PortfolioGroup>
                      </div>
                    )
                  }else{
                    return (
                      <PortfolioGroup
                        key={element.componentId + i}
                        data={element.components}
                        sectionId={props.section.sectionId}
                        pageId={props.pageId}
                        pages={props.pages}
                        currentSectionIndex={props.currentSectionIndex}
                        setCurrentSectionIndex={props.setCurrentSectionIndex}
                        currentPageIndex={props.currentPageIndex}
                        setCurrentPageIndex={props.setCurrentPageIndex}
                        sections={props.sections}
                        showError={props.showError}
                        setShowError={props.setShowError}
                        nvestFilterResult={props.nvestFilterResult}
                        saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                        journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                        channel={journeyState.channel}
                        firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                        setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                        showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                        setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                      ></PortfolioGroup>
                    )
                  }
                }
                else if (element.repeatable) {
                  // console.log("else")
                  // console.log(sectionState.sectionData, element, "abcd1")
                  // let repeatableStateLength 
                  // element.components.forEach((comp) => {
                  //   if(sectionState.sectionData[comp.formControlKey]  && repeatableState[element.componentId] && (sectionState.sectionData[comp.formControlKey].length !== repeatableState[element.componentId].length)){
                  //     console.log(sectionState.sectionData[comp.formControlKey].length, "abcd12", repeatableState[element.componentId].length, "abcd13")
                  //     repeatableStateLength = sectionState.sectionData[comp.formControlKey].length
                  //   }
                  // })
                  // console.log(repeatableStateLength, "abcd15")
                  // if(repeatableStateLength){
                  //   const length = repeatableStateLength
                  //   let arr = []
                  //   for(let i=0; i< length; i++){
                  //     arr.push(element)
                  //   }
                  //   setRepeatableState(prev => {
                  //     return ({
                  //       ...prev,
                  //       [element.componentId]: arr
                  //     })
                  //   })
                  // }

                  if (element.conditions.length === 1) {
                    if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                      return (
                        <div key={props.sectionId + i}>
                          {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                            return (
                              <div key={component.componentId + index + i}>
                                <div className="col-md-12 col-xs-12">
                                  {(index !== 0) && (["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(props.sectionId)) && <hr className="hr-line space-hr" key={component.componentId + index + i + "break-line"} />}
                                </div>
                                <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                  <ComponentGroup
                                    key={component.componentId + index + i}
                                    data={component.components}
                                    sectionId={props.section.sectionId}
                                    pageId={props.pageId}
                                    showError={props.showError}
                                    setShowError={props.setShowError}
                                    repeatable={element.repeatable}
                                    index={index}
                                    journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                    channel={journeyState.channel}
                                    firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                    setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                  ></ComponentGroup>
                                </div>
                                <div className="col-md-12 col-xs-12 text-right">
                                  {(index !== 0) && <span className="provider add-plus-design removeOne" tabIndex="0" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >Remove -</span>}
                                </div>
                              </div>
                            )
                          })}
                          {element.repeatableLimit == null ? 
                          <div className={`add-plus-design text-right addMore col-md-12 col-xs-12`} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span> 
                            </div>:element.repeatable ==true && repeatableState[element.componentId]?.length < element.repeatableLimit &&
                            <div className={`add-plus-design text-right addMore col-md-12 col-xs-12`} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span> 
                            </div>}
                        </div>
                      )
                    }
                  } else if (element.conditions.length > 1) {
                    if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                      return (
                        <div key={props.sectionId + i}>
                          {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                            return (
                              <div key={component.componentId + index + i}>
                                <div className="col-md-12 col-xs-12">
                                  {(index !== 0) && (["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(props.sectionId)) && <hr className="hr-line space-hr" key={component.componentId + index + i + "break-line"} />}
                                </div>
                                <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                  <ComponentGroup
                                    key={component.componentId + index + i}
                                    data={component.components}
                                    sectionId={props.section.sectionId}
                                    pageId={props.pageId}
                                    showError={props.showError}
                                    setShowError={props.setShowError}
                                    repeatable={element.repeatable}
                                    index={index}
                                    journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                    channel={journeyState.channel}
                                    firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                    setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                  ></ComponentGroup>
                                </div>
                                <div className="col-md-12 col-xs-12 text-right">
                                  {(index !== 0) && <span className="provider add-plus-design removeOne" tabIndex="0" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >Remove -</span>}
                                </div>
                              </div>
                            )
                          })}
                          {element.repeatableLimit == null ?  
                          <div className={`add-plus-design text-right addMore col-md-12 col-xs-12`} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span>
                             </div> : element.repeatable ==true && repeatableState[element.componentId]?.length < element.repeatableLimit && 
                            <div className={`add-plus-design text-right addMore col-md-12 col-xs-12`} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span>
                             </div> }
                        </div>
                      )
                    }
                  } else {
                    return (
                      <div key={props.sectionId + i}>
                        {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                          return (
                            <div key={component.componentId + index + i}>
                              <div className="col-md-12 col-xs-12">
                                {(index !== 0) && (["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(props.sectionId)) && <hr className="hr-line space-hr" style={{opacity: "0.75"}} key={component.componentId + index + i + "break-line"} />}
                              </div>
                              <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                <ComponentGroup
                                  key={component.componentId + index + i}
                                  data={component.components}
                                  sectionId={props.section.sectionId}
                                  pageId={props.pageId}
                                  showError={props.showError}
                                  setShowError={props.setShowError}
                                  repeatable={element.repeatable}
                                  index={index}
                                  journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                  channel={journeyState.channel}
                                  firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                  setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                ></ComponentGroup>
                              </div>
                              <div className="col-md-12 col-xs-12 text-right">
                                {(index !== 0) && <span className="add-plus-design removeOne" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} tabIndex="0" onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >
                                  {["nomineePersonalDetail", "proposalFormNomineeDetails"].includes(component.componentId ) ? 'Remove Nominee -' : 'Remove -'}</span>}
                              </div>
                            </div>
                          )
                        })}
                        {element.repeatableLimit == null ? 
                        <div className="provider add-plus-design text-right addMore col-md-12 col-xs-12" key={i + "add-button"} >
                          <span tabIndex="0" onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} >
                            {
                              ["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(props.sectionId)
                                ? 'Add Another Nominee +'
                                : 'Add Another +'}
                          </span>
                        </div>: element.repeatable ==true && repeatableState[element.componentId]?.length < element.repeatableLimit && <div className="provider add-plus-design text-right addMore col-md-12 col-xs-12" key={i + "add-button"} >
                          <span tabIndex="0" onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} >
                            {
                              ["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(props.sectionId)
                                ? 'Add Another Nominee +'
                                : 'Add Another +'
                              }
                          </span>
                        </div>}
                      </div>
                    )
                  }
                } else {
                  if (element.conditions.length === 1) {
                    if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                      if(!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0){
                        if(element.componentId === "existingCustomerPension4life" || element.componentId ===  "namePension4life" || element.componentId === "CPContactUsQuestion" || element.componentId ===  "emailPension4life" || element.componentId === "privacypolicy-MD-12-order-21" || element.componentId === "contactNoPension4life" || element.componentId === "privacyPolicyPension4life"){
                          return (
                              <ComponentGroup
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              setShowError={props.setShowError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                              setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                              ></ComponentGroup>
                          )
                        }
                      }else{
                        return (
                        <ComponentGroup
                          key={element.componentId}
                          data={element.components}
                          sectionId={props.section.sectionId}
                          pageId={props.pageId}
                          pages={props.pages}
                          currentSectionIndex={props.currentSectionIndex}
                          currentPageIndex={props.currentPageIndex}
                          sections={props.sections}
                          showError={props.showError}
                          setShowError={props.setShowError}
                          saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                          journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                          channel={journeyState.channel}
                          firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                          setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                          showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                          setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                        ></ComponentGroup>
                      )
                      }
                    } else { // TO remove error State when item condition fails
                      element.components.map((subElement) => {
                        if (errorState[subElement.formControlKey]) {
                          setErrorState((prev) => {
                            return ({
                              ...prev,
                              [subElement.formControlKey]: ""
                            })
                          })
                        }
                        if (sectionState.sectionData?.[subElement.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                          if ((props.sectionId === "CPSpouseCoverDetails" && subElement.formControlKey === "gender") 
                          || (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && subElement.formControlKey === "nameOfTheIndustry")
                          || (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && subElement.formControlKey === "CPcompanyName")
                          || (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && subElement.formControlKey === "commCity")){
                            
                          } else {
                            setSectionState((prev) => {
                              return ({
                                ...prev,
                                sectionData: {
                                  ...prev.sectionData,
                                  [subElement.formControlKey]: ""
                                }
                              })
                            })
                          }
                         
                        }
                      })
                    }
                  } else if (element.conditions.length > 1) {
                    if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                      if(!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0){
                        if(element.componentId === "existingCustomerPension4life" || element.componentId ===  "namePension4life" || element.componentId === "CPContactUsQuestion" || element.componentId ===  "emailPension4life" || element.componentId === "contactNoPension4life" || element.componentId === "privacypolicy-MD-12-order-21" || element.componentId === "privacyPolicyPension4life"){
                          return (
                              <ComponentGroup
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              setShowError={props.setShowError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                              setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                              ></ComponentGroup>
                          )
                        }
                      }else{
                        return (
                            <ComponentGroup
                              key={element.componentId}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              setShowError={props.setShowError}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                              setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                            ></ComponentGroup>
                          )
                      }
                    } else { // TO remove error State when item condition fails
                      element.components.map((subElement) => {
                        if (errorState[subElement.formControlKey]) {
                          setErrorState((prev) => {
                            return ({
                              ...prev,
                              [subElement.formControlKey]: ""
                            })
                          })
                        }
                        if (sectionState.sectionData?.[subElement.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                          if ((props.sectionId === "CPSpouseCoverDetails" && subElement.formControlKey === "gender")
                          || (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && subElement.formControlKey === "nameOfTheIndustry")
                          || (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && subElement.formControlKey === "CPcompanyName")
                          || (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && subElement.formControlKey === "commCity")) {

                          } else {
                            setSectionState((prev) => {
                              return ({
                                ...prev,
                                sectionData: {
                                  ...prev.sectionData,
                                  [subElement.formControlKey]: ""
                                }
                              })
                            })
                          }
                        }
                      })
                    }
                  } else {
                    if (!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0) {
                      if (element.componentId === "existingCustomerPension4life" || element.componentId ===  "namePension4life" || element.componentId === "CPContactUsQuestion" || element.componentId ===  "emailPension4life" || element.componentId === "contactNoPension4life" || element.componentId === "privacyPolicyPension4life") {
                        if(element.class){
                          return (
                            <div className={element.class} key={element.componentId + i}>
                              <ComponentGroup
                                key={element.componentId + i}
                                data={element.components}
                                sectionId={props.section.sectionId}
                                pageId={props.pageId}
                                pages={props.pages}
                                currentSectionIndex={props.currentSectionIndex}
                                currentPageIndex={props.currentPageIndex}
                                sections={props.sections}
                                showError={props.showError}
                                setShowError={props.setShowError}
                                nvestFilterResult={props.nvestFilterResult}
                                saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                                journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                channel={journeyState.channel}
                                firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                                setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                              ></ComponentGroup>
                            </div>
                          )
                        }else{
                          return (
                            <ComponentGroup
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              setShowError={props.setShowError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                              setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                            ></ComponentGroup>
                          )
                        }
                        
                      }
                    } else {
                      if(element.class) {
                        return (
                          <div className={element.class} key={element.componentId + i}>
                            <ComponentGroup
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              setShowError={props.setShowError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                              setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                            ></ComponentGroup>
                          </div>
                        )
                      }else{
                        return (
                          <ComponentGroup
                            key={element.componentId + i}
                            data={element.components}
                            sectionId={props.section.sectionId}
                            pageId={props.pageId}
                            pages={props.pages}
                            currentSectionIndex={props.currentSectionIndex}
                            currentPageIndex={props.currentPageIndex}
                            sections={props.sections}
                            showError={props.showError}
                            setShowError={props.setShowError}
                            nvestFilterResult={props.nvestFilterResult}
                            saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                            journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                            channel={journeyState.channel}
                            firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                            setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                            showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
                            setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}
                          ></ComponentGroup>
                        )
                      }
                      
                    }
                  }
                }
              })}
            </div>
          </div>
        </div>
         { journeyState?.premium && props.pageId == 'calculatePremiumPage' && ['CPResidentAndOccupationDetailSection','CPCustomizePlanSection','CPOptionInBuiltCoversSection','CPSpouseCoverDetails'].includes(props?.section?.sectionId) 
          ? 
          <div className="total-prem-payment-price ">
            <div className="left-line-pre-pay"></div>
            <h2>Total Premium:  &nbsp; ₹ {journeyState.premium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
          </div>
          : journeyState?.premium && props.pageId == 'PageISelect360CalculatePremium' && ['iSelect360CPResidentAndOccupationDetailSection','iSelect360CPCustomizePlanSection','iSelect360CPOptionalInBuilt','iSelect360CPSpouseCoverDetails'].includes(props?.section?.sectionId) 
          ?
          <div className="total-prem-payment-price ">
            <div className="left-line-pre-pay"></div>
            <h2>Total Premium:  &nbsp; ₹ {journeyState.premium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
          </div>
          : null
        }
      </div>
    </>
  )
}

export default Section
